import { render, staticRenderFns } from "./TransactionConfirmModal.vue?vue&type=template&id=4f7e2e8c"
import script from "./TransactionConfirmModal.vue?vue&type=script&lang=js"
export * from "./TransactionConfirmModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports